import React from 'react';
import { Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PlaylistAddCheckRoundedIcon from '@mui/icons-material/PlaylistAddCheckRounded';
import Tooltip from '@src/components/Tooltip';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import { StyledHeader } from './index.style';

const NotificationHeader = ({ onClose, onMarkAllRead }) => {
  const { t } = useTranslation();

  return (
    <StyledHeader>
      <Typography className="header-title">
        {t('notificationDetail')}
      </Typography>
      <div className="header-actions">
        <Tooltip title={t('notificationMarkAllRead')} placement="bottom" arrow>
          <div
            role="button"
            tabIndex={0}
            className="action-btn"
            onClick={onMarkAllRead}
          >
            <PlaylistAddCheckRoundedIcon
              sx={{ fontSize: 24, color: COLOR.indigo[64] }}
            />
          </div>
        </Tooltip>
        <div
          role="button"
          tabIndex={0}
          className="action-btn"
          onClick={onClose}
        >
          <CloseRoundedIcon sx={{ fontSize: 24, color: COLOR.indigo[64] }} />
        </div>
      </div>
    </StyledHeader>
  );
};

export default NotificationHeader;
